export default "__VITE_ASSET__4598bf51__"